export const GO_BACK_WINDOW_HOURS = 48;

export const GO_BACK_WINDOW_MESSAGE = "A go-back can be requested for 48 hours after the work is finished.";

const HOUR_MS = 3_600_000;

export function withinGoBackWindow(finishedAt: string | null | undefined, now: Date = new Date()): boolean {
  const finished = finishedAt ? new Date(finishedAt).getTime() : Number.NaN;
  return !Number.isNaN(finished) && now.getTime() - finished <= GO_BACK_WINDOW_HOURS * HOUR_MS;
}
